// Catalogue officiel des corps d'état et intervenants BTP utilisable dans CHANTIX.
// Utilisé par le formulaire entreprises (par chantier) et par l'annuaire global.

export const CORPS_ETAT_CATALOG = [
  {
    group: "Intervenants (MOA / MOE / Contrôle)",
    items: [
      { value: "MO", label: "MO — Maître d'Ouvrage" },
      { value: "MOE", label: "MOE — Maîtrise d'Œuvre" },
      { value: "AMO", label: "AMO — Assistant Maître d'Ouvrage" },
      { value: "BET", label: "BET — Bureau d'Études Techniques" },
      { value: "CT", label: "CT — Contrôleur Technique" },
      { value: "CSPS", label: "CSPS — Coordination Sécurité" },
      { value: "OPC", label: "OPC — Ordonnancement Pilotage Coordination" },
      { value: "Géomètre", label: "Géomètre" },
      { value: "Géotechnicien", label: "Géotechnicien / Étude de sol" },
    ],
  },
  {
    group: "Gros œuvre & Structure",
    items: [
      { value: "Terrassement / VRD", label: "Terrassement / VRD" },
      { value: "Fondations spéciales", label: "Fondations spéciales" },
      { value: "Gros œuvre / Maçonnerie", label: "Gros œuvre / Maçonnerie" },
      { value: "Charpente bois", label: "Charpente bois" },
      { value: "Charpente métallique", label: "Charpente métallique" },
      { value: "Démolition / Désamiantage", label: "Démolition / Désamiantage" },
    ],
  },
  {
    group: "Clos & Couvert",
    items: [
      { value: "Couverture", label: "Couverture" },
      { value: "Étanchéité", label: "Étanchéité" },
      { value: "Bardage / Façade", label: "Bardage / Façade" },
      { value: "Menuiseries extérieures", label: "Menuiseries extérieures" },
      { value: "Serrurerie / Métallerie", label: "Serrurerie / Métallerie" },
    ],
  },
  {
    group: "Second œuvre",
    items: [
      { value: "Cloisons / Doublage / Plâtrerie", label: "Cloisons / Doublage / Plâtrerie" },
      { value: "Menuiseries intérieures", label: "Menuiseries intérieures" },
      { value: "Faux plafonds", label: "Faux plafonds" },
      { value: "Revêtements de sol", label: "Revêtements de sol" },
      { value: "Carrelage / Faïence", label: "Carrelage / Faïence" },
      { value: "Peinture / Revêtements muraux", label: "Peinture / Revêtements muraux" },
    ],
  },
  {
    group: "Fluides & Techniques (CFO/CFA)",
    items: [
      { value: "Électricité CFO", label: "Électricité CFO (courants forts)" },
      { value: "Courants faibles (CFA)", label: "Courants faibles (CFA)" },
      { value: "Plomberie sanitaire", label: "Plomberie sanitaire" },
      { value: "CVC / Chauffage / Ventilation / Clim", label: "CVC / Chauffage / Ventilation / Clim" },
      { value: "Photovoltaïque / ENR", label: "Photovoltaïque / ENR" },
      { value: "Ascenseurs / Monte-charges", label: "Ascenseurs / Monte-charges" },
    ],
  },
  {
    group: "Aménagements & Extérieurs",
    items: [
      { value: "Espaces verts / Paysagiste", label: "Espaces verts / Paysagiste" },
      { value: "Voirie & Réseaux Divers (VRD)", label: "Voirie & Réseaux Divers (VRD)" },
      { value: "Signalisation / Marquage", label: "Signalisation / Marquage" },
      { value: "Mobilier urbain", label: "Mobilier urbain" },
    ],
  },
  {
    group: "Autre",
    items: [
      { value: "Autre", label: "Autre (à préciser dans la note)" },
    ],
  },
];

// Set plat de toutes les valeurs valides — pratique pour de la validation ou du styling.
export const CORPS_ETAT_VALUES = new Set(
  CORPS_ETAT_CATALOG.flatMap(g => g.items.map(i => i.value))
);

// Retourne le label affichable pour une valeur donnée (avec fallback sur la valeur brute).
export function getCorpsEtatLabel(value) {
  if (!value) return "";
  for (const g of CORPS_ETAT_CATALOG) {
    const found = g.items.find(i => i.value === value);
    if (found) return found.label;
  }
  return value;
}
